<template>
  <div class="main-container">
    <div class="search-box btn3" :class="{ 'close': !searchMore }">
      <div class="input-item select-two">
        <Select v-model="searchParams.dateType" :transfer="true">
          <Option value="1">创建日期</Option>
          <Option value="2">支付日期</Option>
          <Option value="3">批改生效日期</Option>
        </Select>
        <DatePicker
          v-model="searchParams.date"
          type="daterange"
          split-panels
          separator=" 至 "
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
          <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item select-two">
        <Select v-model="searchParams.orderType" :transfer="true">
          <Option value="1">保单号</Option>
          <Option value="2">批单号</Option>
          <Option value="3">批单ID</Option>
        </Select>
        <Input v-model="searchParams.no" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">状态</span>
        <Select v-model="searchParams.statusList" multiple :max-tag-count="2" :transfer="true" clearable>
          <Option value="-15">核保失败</Option>
          <Option value="0">待提交</Option>
          <Option value="20">待支付/确认</Option>
          <Option value="-99">已撤销</Option>
          <Option value="30">待实收</Option>
          <Option value="40">待承保</Option>
          <Option value="-20">批改失败</Option>
          <Option value="50">已完成</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人名称</span>
        <Input v-model="searchParams.holderName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人证件号</span>
        <Input v-model="searchParams.cardNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item" v-if="userInfo.userType != 4">
        <span class="label">所属机构/团队</span>
        <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
      </div>
      <div class="input-item" v-if="userInfo.userType != 4">
        <span class="label">业务员</span>
        <Select clearable v-model="searchParams.salesmanId" style="width: 256px" filterable :transfer="true">
          <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index" :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">变更类型</span>
        <Select v-model="searchParams.type" :transfer="true" clearable>
          <Option value="1">增保</Option>
          <Option value="3">减保</Option>
          <Option value="2">替保</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box">
      <div class="total-box">
        <span>
          共<b>{{ totalInfo.counts }}</b
          >单
        </span>
        <span>
          已支付保费：<b>{{ totalInfo.issueFee | number_format(2) }}</b
          >元
        </span>
        <span>
          已支付服务费：<b>{{ totalInfo.commissionPrice | number_format(2) }}</b
          >元
        </span>
      </div>
      <Button type="warning" @click="exportToExcel" v-show="$units.pointAction('order_40_2_4')">导出</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellTypes">
            <Tag color="blue" v-if="row.sellTypes.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>
        <template slot-scope="{ row }" slot="orderNo">
          <div>
            <p :class="{ 'line-text': row.policyNo }" @click="row.policyNo && goDetail(row)">{{ row.policyNo || '-' }}</p>
            <p>{{ row.billNo || '-' }}</p>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" v-if="row.status != '-99'" @click="detail(row)">详情</span>
          <span v-else>-</span>
          <span class="table-btn" @click="$refs.serviceFeeModalNew.open(row.policyNo, row.billNo)" v-if="$units.pointAction('order_40_2_6')">服务费</span>
          <span v-if="$units.pointAction('order_40_2_2') && row.billFiles && row.status == '50'" class="table-btn" @click="exportBillFiles(row)">下载批单</span>
          <span
            v-if="$units.pointAction('order_40_2_3') && (row.status == '-15' || row.status == '0' || row.status == '20')"
            class="table-btn"
            @click="reset(row)"
            >撤销</span
          >
        </template>
      </Table>
    </div>
    <Page
      :total="total"
      :current="pageNum"
      :page-size="pageSize"
      show-total
      @on-change="getList"
      style="text-align: center"
      show-sizer
      :page-size-opts="[10, 20, 30, 50, 100]"
      @on-page-size-change="pageSizeChange"
    />

    <!-- 服务费弹窗新版 -->
    <service-fee-modal-new ref="serviceFeeModalNew"></service-fee-modal-new>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool, common } from '@/api/mixins';
import { mapState } from 'vuex';
import { config } from './index.config.js';
import selectTree from '@/components/system/selectTree3';
import serviceFeeModalNew from './components/serviceFeeModalNew';
export default {
  mixins: [pageTool, config, common],
  components: {
    selectTree,
    serviceFeeModalNew
  },
  data() {
    return {
      listLoading: false,
      totalInfo: {}, //统计信息
      companyList: [],
      salesmanList: [] //所属业务员
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.tableData = [];
    this.getColumns();
    this.getCompanyList();
    this.getOrganizationUser(null);
    if (this.$route.query.statusList) {
      this.searchParams.statusList = this.$route.query.statusList;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    this.initListAjax('/buz/endorsement/read/list');
  },
  activated() {
    if (this.$route.query.statusList) {
      this.searchParams.statusList = this.$route.query.statusList;
      this.$nextTick(() => {
        this.searchMore = true;
      });
      this.getList();
    }
  },
  methods: {
    setReqParams(params) {
      params.apiPermissionCode = 'order_40_2_0';
    },
    listCallback() {
      this.getTotalInfo();
    },
    // 获取统计信息
    getTotalInfo() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$http({
        url: `/buz/endorsement/count`,
        type: 'POST',
        data: params
      }).then(res => {
        this.totalInfo = res.data;
      });
    },
    exportBillFiles(row) {
      window.open(row.billFiles);
    },
    // 导出
    exportToExcel() {
      this.listLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: '/buz/endorsement/export',
        type: 'POST',
        responseType: 'blob',
        data: params,
        apiPermissionCode: 'order_40_2_4'
      })
        .then(res => {
          this.listLoading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    reset(row) {
      this.$notice.inquiry('请确认是否要撤销？').then(async () => {
        this.$http({
          url: `/buz/endorsement/cancel`,
          type: 'GET',
          data: {
            businessNo: row.businessNo
          },
          apiPermissionCode: 'order_40_2_3'
        }).then(res => {
          this.$Message.success('操作成功');
          this.initListAjax('/buz/endorsement/read/list');
        });
      });
    },
    goDetail(row) {
      this.$router.push({
        path: '/orderManage/group/peservation/policyDetail',
        query: {
          id: row.policyId || '',
          policyNo: row.policyNo,
          orderNo: row.orderNo,
          dockChannel: row.dockChannel,
          payType: row.payType,
          productCategory: row.productCategory, //1-团险 2-财产险 3、个险
          status: row.status, //保单状态 1-保障中 -1-退保 0-终止
          type: row.type,
          workName: 'peservation'
        }
      });
    },
    // 详情
    detail(row) {
      // 桐心企业保
      if (row.policyType == 1 || row.dockChannel == 3) {
        this.$http({
          url: `/buz/endorsement/detail?id=${row.id}`,
          type: 'GET'
        }).then(res => {
          window.open(res.data, '_blank');
        });
      } else {
        this.openPageTabTags('/orderManage/group/peservation/detail', { id: row.id, policyNo: row.policyNo });
      }
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: 'POST',
        data: {
          orgaList: id ? [id] : []
        }
      }).then(res => {
        this.salesmanList = res.data;
      });
    },

    // 通过机构获取业务员
    getGroupUser(id) {
      this.$http({
        url: `/buz/userBase/getByGroup?groupId=${id}`,
        type: 'GET'
      }).then(res => {
        this.salesmanList = res.data;
      });
    },
    // 组织选择
    selectTreeChange(data) {
      this.searchParams.salesmanId = '';
      if (data.nodeType == 1) {
        //机构
        this.searchParams.organizationId = data.id;
        this.getOrganizationUser(data.id);
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.organizationId = '';
        this.getGroupUser(data.id);
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.organizationId = '';
        this.salesmanList = [];
        this.searchParams.groupId = '';
      }
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 转化参数
    setListParams(params) {
      delete params.applyOrgId;
      delete params.orderNo;
      delete params.policyNo;
      delete params.billNo;
      if (params.date && params.date[0]) {
        let date1 = dayjs(params.date[0]).format('YYYY-MM-DD');
        let date2 = dayjs(params.date[1]).format('YYYY-MM-DD');
        if (params.dateType == 1) {
          //投保日期
          params.createTimeStart = date1;
          params.createTimeEnd = date2;
        } else if (params.dateType == 2) {
          //支付日期
          params.payTimeStart = date1;
          params.payTimeEnd = date2;
        } else if (params.dateType == 3) {
          //起保日期
          params.startTimeStart = date1;
          params.startTimeEnd = date2;
        }
      }
      if (params.orderType && params.no) {
        if (params.orderType == 1) {
          //保单号
          params.policyNo = params.no;
        } else if (params.orderType == 2) {
          //批单号
          params.billNo = params.no;
        } else if (params.orderType == 3) {
          //批单ID
          params.businessNo = params.no;
        }
      }
      // if (params.status == '-9') {
      //   params.checkInsuranceStatus = '-9';
      //   delete params.status;
      // } else {
      //   delete params.checkInsuranceStatus;
      // }
      delete params.orderType;
      delete params.dateType;
      delete params.no;
      delete params.date;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

/deep/.select-two .ivu-select {
  width: 116px !important;
}
.line-text {
  color: #236dff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.total-box {
  span {
    padding-right: 10px;
  }

  b {
    color: #236dff;
    font-weight: 400;
  }
}
</style>
